<!-- eslint-disable max-lines -->
<template>
    <paper v-loading="btnloading" class="customer-visit-flow" >
        <div class="top-box-resp">
            <!-- 按钮区域 -->
            <div class="detail-toolBar-resp">
                <lots-button size="mini" type="primary" v-if="showBtn['submit']"
                    @click="submitMip" :loading="saveLoading">
                    {{ detailDataLocal.fdId && !showBtn.hasApproval ? 'mip提交' : '提交' }}
                </lots-button>
                <lots-button size="mini" type="primary" v-if="showBtn['reject']"
                    @click="handleReject" >
                    驳回
                </lots-button>
                <lots-button size="mini" type="primary" v-if="showBtn['transfer']"
                    @click="openTransferDialog">
                    转办
                </lots-button>
            </div>
        </div>
        <div class="resp-hr"></div>
        <div class="customer-visit-detail" v-loading="detailLoading">
            <!-- 表单区域 -->
            <collapse-infos ref="upholdHealder" :detailData="detailDataLocal" :collapse="COLLAPSE"
                :activeCollapses="activeCollapses" @change="handleInfosChange">
                <!-- 折叠筐标题插槽 -->
                <template v-slot:collapse-title-append="{ collapseItem }">
                    <span>{{ collapseItem.title }}</span>
                </template>
                <!-- 表单字段插槽 -->
                <template v-slot:collapse-append="{ form, itemSetting, rIndex, collapseItem, dictData }">
                    <span v-if="itemSetting.prop === 'fileList'">
                        <lots-upload-button v-if="showBtn.editBtn" ref="uploadRef" :disabled="form[itemSetting.prop] && form[itemSetting.prop].length > 4" :text="'上传附件'" :bucket="'annto-lcrm'"
                            @callback="(data) => { upLoadData(form, itemSetting, data); }" @beforeUpload="beforeUpload">
                        </lots-upload-button>
                        <div class="file-infos">
                            <template v-if="form[itemSetting.prop]
                                && form[itemSetting.prop].length">
                                <div class="file-list" v-for="(item, index) in form[itemSetting.prop]"
                                    :key="index + item.fileName">
                                    <div class="file-name upload" :title="item.fileName">
                                        {{ `${index + 1}. ` }}
                                        <span class="file-link" @click="handleDownload(item)">{{ item.fileName }}</span>
                                    </div>
                                    <div class="delete-btn">
                                        <el-button type="text" plain @click="handlePreview(item)">
                                            预览
                                        </el-button>
                                        <el-button type="text" plain @click="handleDownload(item)">
                                            下载
                                        </el-button>
                                        <el-button type="text"
                                            v-if="showBtn.editBtn"
                                            plain
                                            @click="handleDeleteFile(form, itemSetting, index)">删除</el-button>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </span>
                    <span v-else-if="['issues','content'].includes(itemSetting.prop)" class="custom-span custom-texteare" :title="form[itemSetting.prop]">
                        {{ form[itemSetting.prop] ? form[itemSetting.prop] : '--' }}
                    </span>
                    <span v-else-if="['dataType'].includes(itemSetting.prop)" class="custom-span">
                        {{ (form[itemSetting.prop] || form[itemSetting.prop] === 0) ? codesToNames(form[itemSetting.prop],dictDatas['SYNC_BIG_DATA_TYPE']) : '--' }}
                    </span>
                    <span v-else-if="!itemSetting.optionsKey" class="custom-span" :title="form[itemSetting.prop]">
                        {{ (form[itemSetting.prop] || form[itemSetting.prop] === 0) ? form[itemSetting.prop] : '--' }}
                    </span>

                </template>
            </collapse-infos>

            <!-- iflow区域 -->
            <el-collapse v-if="detailDataLocal.fdId && showBtn.submitStatus" class="contract-collapse detail-more-collapse" value="mipInfo">
                <el-collapse-item title="流程信息" name="mipInfo">
                    <div class="header-operation">
                        <!-- <lots-button size="mini" type="primary" v-if="!['7'].includes(detailDataLocal.approvalStatus + '')"
                            @click="submitMip" :loading="btnloading">
                            mip提交
                        </lots-button> -->
                    </div>
                    <iframe class="ifr" :src="mipUrl" v-if="!btnloading" />
                </el-collapse-item>
            </el-collapse>
        </div>

        <transfer-dialog ref="transferDialogRef" @confirm="handleTransferConfirm" />
    </paper>
</template>

<script>
import { ref, computed, getCurrentInstance, onMounted, onActivated } from '@vue/composition-api';
import paper from '@/components/core/Paper.vue';
import lotsButton from '@/components/lots/lotsButton';
import lotsUploadButton from '@/components/lots/oss/UploadBtn';
import CollapseInfos from '@/modules/mdm/views/contractModules/components/collapseInfos/CollapseInfos.vue';
import {
    submitCustomerVisit, getCustomerVisitDetail, transferCustomerVisitApi, rejectCustomerVisitApi } from '@mdm/api/customer/customerVisitManage.js';
import { filePreview } from '@/utils/filePreview.js';
import { getNodesAndOperationApi } from '@mdm/utils/flowUtils.js';
import { approveProcess } from '@/modules/mdm/api/contractManage/detailMainApi.js';
import { Message, MessageBox } from 'element-ui';
import store from '@/store/index';
import utils from '@/components/utils/common.js';
import { collapse } from './collapseInfosConfig.js';
import _ from 'lodash';
import configurl from '@/config/user.env';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import transferDialog from './component/transferDialog/Index.vue';
const { MAGIC_NUMBER } = utils;
export default {
    name: 'customerVisitFlow',
    components: {
        paper,
        lotsButton,
        CollapseInfos,
        lotsUploadButton,
        transferDialog
    },
    props: { },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const ctx = getCurrentInstance(); // 通过该方法访问当前组件的实例对象,相当于this
        const config = _.cloneDeep(collapse);
        const detailLoading = ref(false);
        const btnloading = ref(false);
        const detailDataLocal = ref({
            fdId: '',
            fileList: []
        });

        // * 1：草稿；
        // * 2：待审批；
        // * 3：审批中；
        // * 4：审批通过；
        // * 5：审批驳回；
        // * 6：撤回；
        // * 7：作废

        // const authority = store.getters.authority;
        // eslint-disable-next-line max-len
        const activeCollapses = ref(['basicInfo']);
        const mipUrl = ref('');
        const COLLAPSE = computed(() => { // 配置项动态计算
            config.forEach((v, i) => {
                // eslint-disable-next-line complexity
                v.formList.forEach((v2, i2) => {
                    if (['visitMode'].includes(v2.prop)) {
                        v2.type = showBtn.value.editBtn ? 'select' : 'custom';
                        v2.rule[0].required = showBtn.value.editBtn;
                    }
                    if (['content'].includes(v2.prop)) {
                        v2.type = showBtn.value.editBtn ? 'input' : 'custom';
                    }
                    if (['fileList'].includes(v2.prop)) {
                        v2.type = showBtn.value.editBtn ? 'custom' : 'custom';
                        v2.rule[0].required = showBtn.value.editBtn;
                    }
                });
            });
            return config;
        });
        // eslint-disable-next-line complexity
        const showBtn = computed(() => {
            const { statusCode, fdId, ownerCode } = detailDataLocal.value;
            const isOwner = ownerCode === userCode;
            const canProcess = ['processing', 'expired'].includes(statusCode?.toString());
            // const isNoFdId = !fdId;
            // const canOperate = isNoFdId && isOwner && canProcess;
            const hasApproval = fdId && canProcess;
            // const finishedStatus = ['completed', 'abandoned', 'expired', 'timeout'].includes(statusCode?.toString());
            // const canShowBtn = isOwner && canProcess && !finishedStatus;
            const submitStatus = ['approval', 'completed', 'abandoned', 'expired', 'timeout'].includes(statusCode?.toString());
            return {
                editBtn: isOwner && canProcess,
                // 流程未发起拜访责任人 有按钮权限
                // 流程发起,进行中,审批中
                // 流程发起,审批中,已完成,已废弃,已过期,超时完成  已废弃需要吗?
                submit: (!fdId && isOwner) || (fdId && canProcess && isOwner) || (fdId && submitStatus),
                reject: isOwner && canProcess,
                transfer: isOwner && canProcess,
                hasApproval,
                submitStatus
            };
        });

        const newMip = ref(false);
        // 处理详情返回数据格式
        const formatData = (data) => {
            const newData = _.cloneDeep(data);
            !newData.fileList && (newData.fileList = []);
            return newData;
        };
        const { userName, userCode } = store.getters.user;
        const currentNodeInfo = ref({});
        // eslint-disable-next-line complexity
        const _initData = async () => {
            const { id } = ctx.$route.query;
            detailLoading.value = true;
            if (id) {
                try {
                    await getCustomerVisitInfo();
                    const { fdId, mipType, mipStatus } = detailDataLocal.value;
                    if (!fdId) {
                        detailLoading.value = false;
                        handleInfosChange({ form: formatData(detailDataLocal.value) });
                        return;
                    };
                    detailLoading.value = false;
                    currentNodeInfo.value = {
                        mipFlowId: fdId, // 流程id
                        mipType, // 流程类型
                        mipStatus // 流程状态
                    };
                } catch (error) {
                    // detailLoading.value = false;
                }
            }
            detailLoading.value = false;
            handleInfosChange({ form: formatData(detailDataLocal.value) });
        };
        const currentAuth = ref(false);
        const isHandleEdit = ref(false);
        // eslint-disable-next-line complexity
        const handleInfosChange = async (formObjData = {}) => { // 表单组件编辑回调，更新本地数据
            const { itemSetting, targetForm } = formObjData;
            // 监控表单是否编辑过
            if (!itemSetting) { // 页面初始化、刷新时走：
                if (detailDataLocal.value.fdId) {
                    handleCreate(); // 渲染iflow流程
                    currentAuth.value = await getNodesAndOperationApi({ fdId: detailDataLocal.value.fdId, loginName: userCode });
                }
                setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.clearValidate(); // 重置校验报错
                setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.refleshPage(detailDataLocal.value); // 刷新表单子组件
            } else { // collapse组件编辑回调时走：
                const { fileList } = detailDataLocal.value;
                // 除了插槽参数以外，其他参数取最新编辑的参数更新(因：插槽的编辑不会触发collapse组件change事件回调，因此change事件回调的插槽的参数是旧数据不能取)
                detailDataLocal.value = Object.assign(
                    {},
                    detailDataLocal.value,
                    formObjData.form,
                    targetForm,
                    { fileList }
                );
            }
        };
        const handleCreate = () => {
            mipUrl.value = '';
            mipUrl.value = `${configurl.iflowUrl}?fdId=${detailDataLocal.value.fdId}&fdTemplateKey=CRM_customer_visit&userCode=${userCode}&userName=${userName}`;
            createMetaNode();
            window.addEventListener('message', messageFunc, false);
            newMip.value && setTimeout(() => {
                const element = document.getElementsByClassName('customer-visit-flow')[0];
                element.scrollTo(0, MAGIC_NUMBER.TWO_THOUSAND); // 页面滚动到MIP审批位置
                newMip.value = false;
            }, MAGIC_NUMBER.FOUR_HUNDRED);
        };
        const createMetaNode = () => {
            const mipmeta = document.getElementById('mipmeta');
            if (mipmeta) {
                return false;
            }
            const meta = document.createElement('meta');
            meta.httpEquiv = 'Content-Security-Policy';
            meta.content = 'upgrade-insecure-requests';
            meta.id = 'mipmeta';
            document.getElementsByTagName('head')[0].appendChild(meta);
        };
        const timer = 1800;
        // approveProcess 回调提取为独立函数，减少嵌套
        const handleApproveProcess = (params) => {
            return approveProcess(params).then(res => {
                if (res && +res.code === 0) {
                    Message.success('提交成功');
                    const times = setTimeout(async () => {
                        _initData();
                        clearTimeout(times);
                    }, timer);
                } else {
                    Message.error(res.msg);
                }
            }).finally(() => {
                btnloading.value = false;
            });
        };
        // 参数准备辅助函数
        const prepareApproveParams = (eventData) => {
            const { id, fdId } = detailDataLocal.value;
            const { origin, pathname } = window.location;
            const params = eventData.data || {};
            const { tenantCode } = store.getters.currentTenant;
            params.tenantCode = tenantCode;
            params.currentApplicationCode = 'APP201904230047';
            if (params.formParam) {
                const { processParam } = params;
                let isToOtherPersons = '';
                if (processParam.operationType === 'circulate' && processParam.toOtherPersons) {
                    isToOtherPersons = processParam.toOtherPersons;
                }
                // eslint-disable-next-line max-len
                params.formParam.fdUrl = `${origin}${pathname}#/customerVisitFlow?id=${id}&fdId=${fdId}${isToOtherPersons ? `&isToOtherPersons=${isToOtherPersons}` : ''}`;
            }
            return params;
        };
        // draft_submit分支处理
        const handleDraftSubmit = async (params) => {
            try {
                await handleApproveProcess(params);
            } catch (e) {
                btnloading.value = false;
            }
        };
        // 主流程调度
        const messageFunc = async (event) => {
            if (currentTime.value !== store.getters.iflowPage.pageTime) return;
            if (!(event.data && event.data.data && event.data.success)) return;
            // handler_commission 转办类型
            if (_.get(event, 'data.data.processParam.operationType', '') === 'handler_commission') {
                const toOtherPersons = _.get(event, 'data.data.processParam.toOtherPersons', '');
                if (toOtherPersons === detailDataLocal.value.ownerCode) {
                    return Message.warning('转办审批人时不允许选择拜访责任人，请重新选择!');
                }
            }
            btnloading.value = true;
            const params = prepareApproveParams(event.data);
            await handleDraftSubmit(params);
        };
        // eslint-disable-next-line complexity
        const submitMip = async () => {
            if (showBtn.value.editBtn) {
                handleSave();
                return;
            }
            const content = window;
            content.frames && content.frames.length && content.frames[0]
                && content.frames[0].postMessage('mbpm_getApprovalData', mipUrl.value);
            content.frames && content.frames.length && content.frames[1]
                && content.frames[1].postMessage('mbpm_getApprovalData', mipUrl.value); // 解决接入了智能客服后，content.frames[0]被占用了的问题
            currentTime.value = new Date().getTime();
            store.commit('updateIflowPage', { pageTime: currentTime.value });
        };
        const currentTime = ref('');
        const saveLoading = ref(false);

        const checkSubmit = () => {
            const data = _.cloneDeep(setupContext.refs.upholdHealder.onsave());
            if (!data) return false;
            data.fileList = detailDataLocal.value.fileList;
            return data;
        };
        const handleSave = () => {
            if (!showBtn.value.editBtn) {
                return {};
            }
            const data = checkSubmit();
            if (!data) {
                return false;
            }
            const params = _.pick(data, ['id', 'visitCode', 'visitMode', 'content', 'fileList']);
            saveLoading.value = true;

            return submitCustomerVisit(params).then(res => {
                if (+res.code === 0 && res.data) {
                    newMip.value = true;
                    isHandleEdit.value = false;
                    Message.success('保存成功');
                    const timer = setTimeout(() => {
                        _initData();
                        clearTimeout(timer);
                    // eslint-disable-next-line no-magic-numbers
                    }, 2000); // 流程异步更新任务状态需要时间
                }
            }).finally(() => { saveLoading.value = false; });
        };
        const handleEdit = () => {
            isHandleEdit.value = true;
        };
        const flowLoading = ref(false);

        const getCustomerVisitInfo = () => {
            const id = ctx.$route.query.id || detailDataLocal.value.id;
            if (!id) return;
            isHandleEdit.value = false;
            btnloading.value = true;
            return getCustomerVisitDetail({
                id
            }).then(res => {
                if (res && +res.code === 0) {
                    detailDataLocal.value = res.data || {};
                    setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.refleshPage(detailDataLocal.value); // 刷新表单子组件
                }
            }).finally(() => {
                btnloading.value = false;
            });
        };
        // eslint-disable-next-line complexity
        const upLoadData = async (form, itemSetting, data) => {
            const { prop } = itemSetting;
            form[prop] = form[prop] ? form[prop] : [];
            if (data && +data.code === 0) {
                form[prop].push({ fileName: data.data.name, fileUrl: data.data.downUrl });
                const formRefs = setupContext.refs.upholdHealder.$refs.dcForm;
                if (prop === 'fileList') {
                    if (itemSetting.rule[0].required) {
                        const targetRef = formRefs.find(item => item._props.refName === 'basicForm');
                        targetRef.$refs['basicForm'].validateField(prop);
                    }
                    detailDataLocal.value = Object.assign({}, detailDataLocal.value, form);
                    isHandleEdit.value = true;
                }
            }
        };
        const beforeUpload = ({ file }) => {
            // eslint-disable-next-line no-magic-numbers
            const maxSize = 10 * 1024 * 1024;
            if (file.size > maxSize) {
                Message.warning('文件大小不能超过10M');
                setupContext.refs.uploadRef.handleUploadStatus(false);
                setupContext.refs.uploadRef.uploadDataArr = [];
                return false;
            }
            setupContext.refs.uploadRef.handleUploadStatus(true);
            return true;
        };
        const handleDeleteFile = (form, itemSetting, index) => {
            const { prop } = itemSetting;
            form[prop].splice(index, 1);
            detailDataLocal.value = Object.assign({}, detailDataLocal.value, form);
            const formRefs = setupContext.refs.upholdHealder.$refs.dcForm;
            if (prop === 'fileList' && itemSetting.rule[0].required) {
                const targetRef = formRefs.find(item => item._props.refName === 'basicForm');
                targetRef.$refs['basicForm'].validateField(prop);
            }
            isHandleEdit.value = true;
        };
        const handlePreview = (row) => {
            filePreview({
                fileUrl: row.fileUrl,
                fileName: row.fileName
            });
        };
        const handleDownload = async (row) => {
            try {
                const response = await fetch(row.fileUrl);
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = row.fileName;
                link.click();
                window.URL.revokeObjectURL(url);
            } catch (e) {
                const link = document.createElement('a');
                link.href = row.fileUrl;
                link.download = row.fileName;
                link.target = '_blank';
                link.click();
            }
            Message.success('下载成功');
        };
        const openTransferDialog = () => {
            setupContext.refs.transferDialogRef.show();
        };
        const handleTransferConfirm = (data) => {
            const { id } = detailDataLocal.value;
            if (!id) return;
            btnloading.value = true;
            const params = {
                id,
                ownerCode: data.ownerCode,
                ownerName: data.ownerName
            };
            transferCustomerVisitApi(params).then(res => {
                if (res && +res.code === 0) {
                    Message.success('转办成功');
                    setupContext.refs.transferDialogRef.handleClose();
                    getCustomerVisitInfo();
                }
            }).finally(() => {
                btnloading.value = false;
            });
        };
        const handleReject = () => {
            const { id, customerName } = detailDataLocal.value;
            if (!id) return;
            MessageBox.confirm(
                `确认要驳回客户【${customerName}】的拜访任务吗？`,
                '驳回确认',
                {
                    confirmButtonText: '确认驳回',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).then(() => {
                btnloading.value = true;
                rejectCustomerVisitApi({ id }).then(res => {
                    if (res && +res.code === 0) {
                        Message.success('驳回成功');
                        getCustomerVisitInfo();
                    } else {
                        Message.error(res.msg || '驳回失败');
                    }
                }).finally(() => {
                    btnloading.value = false;
                });
            }).catch(() => {});
        };
        const dictDatas = ref({});
        onMounted(async () => {
            dictDatas.value = await otherUtils.getDictDataList([], []);
        });
        onActivated(() => {
            const id = ctx.$route.query.id;
            if (id === detailDataLocal.value.id) return;
            detailDataLocal.value = { };
            setupContext.root.$nextTick(() => {
                _initData();
                setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.clearValidate(); // 重置校验报错
            });
        });
        return {
            config,
            COLLAPSE,
            detailLoading,
            btnloading,
            detailDataLocal,
            mipUrl,
            activeCollapses,
            saveLoading,
            showBtn,
            flowLoading,
            isHandleEdit,
            dictDatas,
            codesToNames: otherUtils.codesToNames,
            handleInfosChange,
            submitMip,
            handleEdit,
            upLoadData,
            beforeUpload,
            handleDeleteFile,
            handlePreview,
            handleDownload,
            openTransferDialog,
            handleTransferConfirm,
            handleReject
        };
    }
};
</script>
<style lang="less" scoped>

.customer-visit-flow {
    // overflow: auto;
    display: flex;
    flex-direction: column;

    .top-box-resp {
        .header-box {
            width: 100%;

            h4 {
                text-align: center;
                font-size: 20px;
                margin: 0;
                color: #606266;
            }

            .header-info-crm {
                width: 100%;
                display: flex;
                font-size: 14px;
                border-bottom: 1px solid #dde0e6;
                margin-bottom: 10px;
                padding-bottom: 5px;

                .tips {
                    flex: 1;
                    // color: red;
                    color: #606266;
                    line-height: 20px;
                }

                .apply-info {
                    width: 200px;
                    line-height: 20px;
                    color: #606266;
                    margin-left: 10px;
                }
            }
        }

        .detail-toolBar-resp {
            .item-flow-right {
                float: right;

                &.refresh {
                    margin-left: 10px;
                }
            }
        }
    }
    .resp-hr{
        border-bottom: 1px solid #EBEEF5;
        margin: 10px 0 5px 0;
    }
    .customer-visit-detail {
        overflow: auto;

        .upload-demo {
            display: inline-block;
        }

        .down-mould-btn {
            margin-left: 5px;
        }

        .upload-tips {
            display: inline-block;
            margin-left: 10px;
            line-height: 28px;
            font-size: 12px;
            color: #606266;
        }

        .file-infos {
            width: 100%;
            padding: 0 10px 0 0;

            .file-list {
                width: 100%;
                padding: 2px 0 2px 0px;
                display: flex;

                // justify-content: space-between;
                .file-name {

                    // flex: 1;
                    &.upload {
                        width: 500px;
                    }

                    padding-right: 5px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: inline-block;

                    .file-link {
                        color: #4285F5;
                        cursor: pointer;
                    }
                }

                .view-btn,
                .delete-btn {
                    width: 200px;
                    display: flex;

                    a {
                        color: #4285F5;
                    }

                    .el-button:focus,
                    .el-button:hover,
                    .el-button:active,
                    .el-button.is-disabled {
                        outline: none !important;
                        border-color: transparent !important;
                        /* 可选：如果要去除激活时的边框颜色变化 */
                    }
                }
                .delete-file-btn{
                    margin-left: 10px;
                }
                .import-file-text{
                    color: #0000ee!important;
                }
                a{
                    text-decoration: none;
                }
            }
        }

        .el-collapse-item__content {
            padding-bottom: 5px;
        }

        .el-collapse-item__arrow {
            margin: 0 8px 0 5px;
        }

        .el-button.is-disabled.is-plain,
        .el-button.is-disabled.is-plain:focus,
        .el-button.is-disabled.is-plain:hover {
            border-color: #FFF;
        }
        .resp-remark-wrap{
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp:10; /* 限制行数 */
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: pre-wrap; /* 保留空格和换行 */
            word-break: break-all; /* 允许单词内换行 */
        }

        .width-small {
            width: 340px;
        }

        .width-middle {
            width: 500px;
        }

        .width-large {
            width: 1200px;
        }

        .el-col.el-col-23.form-item {
            .el-form-item.el-form-item--mini {
                margin-bottom: 18px;
            }
        }

        .el-collapse-item__header {
            height: 32px;
        }

        .detail-form-collapse {
            padding-right: 10px;
        }

        .score-config-item-box {
            .item-tittle {
                font-size: 14px;
                font-weight: 600;
                color: #606266;
                margin-left: 28px;
            }
        }
        .rating-score-list-box {
            .el-collapse {
                border-bottom: none;

                .el-collapse-item__header {
                    border-bottom: none;
                }

                .el-collapse-item__wrap {
                    border-bottom: none;
                }
            }
        }
    }

    .ifr {
        width: 100%;
        height: 100vh;
        border: none;
    }

    .el-collapse-item__header {
        color: #606266;
        font-size: 14px;
        font-weight: 600;
    }

    .header-operation {
        margin-top: 10px;
    }

    .resistr-add {
        float: right;
        margin-bottom: 8px;
        margin-right: 8px;
    }
    .custom-texteare{
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        word-break: break-all;
        white-space: pre-wrap;
    }
}

.no-auth-reg {
    font-size: 16px;
    padding: 20px;
    background: #fff;
    width: 100%;
}

.my-tooltip-box {
    width: 800px;
}
</style>
